/**
 * Streak Ring Widget
 * SVG donut chart showing current streak vs target.
 * Moved from StudentDashboardBeta (Phase 3.2 extraction).
 */

import React from 'react'

export interface StreakWidgetProps {
  current: number
  best: number
  target: number
  className?: string
}

const StreakWidget: React.FC<StreakWidgetProps> = ({
  current,
  best,
  target,
  className = '',
}) => {
  const r = 30
  const circ = 2 * Math.PI * r
  const safeTarget = target > 0 ? target : 7
  const offset = circ - (Math.min(current, safeTarget) / safeTarget) * circ

  return (
    <div className={className}>
      <div className="relative w-[72px] h-[72px] mx-auto mt-[4px]">
        <svg viewBox="0 0 72 72" className="w-[72px] h-[72px] -rotate-90">
          <circle
            cx="36" cy="36" r={r} fill="none" strokeWidth="5"
            stroke="var(--color-g200)" strokeLinecap="round"
          />
          <circle
            cx="36" cy="36" r={r} fill="none" strokeWidth="5"
            stroke="var(--color-amber-accent)" strokeLinecap="round"
            strokeDasharray={circ} strokeDashoffset={offset}
            className="transition-[stroke-dashoffset] duration-800"
            style={{ filter: 'drop-shadow(0 0 4px rgba(212,161,68,.35))' }}
          />
        </svg>
        <span
          className="absolute inset-0 flex items-center justify-center text-[24px] font-black"
          style={{ color: 'var(--color-amber-accent)' }}
        >
          {current}
        </span>
      </div>
      <p className="text-center text-[11px] text-[var(--color-text-tertiary)] mt-[5px] font-medium">
        of {safeTarget} · best {best}
      </p>
    </div>
  )
}

export default StreakWidget
